import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Layout from "../assets/images/certificate.png";
import { useEffect, useState } from "react";
import { formatDateWithCurrentYear, getCertificateData } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CertificateView = () => {
  const [clicked, setClicked] = useState(false);
  const [data, setData] = useState<any>({});
  const navigate = useNavigate()
  useEffect(() => {
    const data = getCertificateData()
    if (data === null || data === undefined || !data) {
      navigate('/parent/home')
    }
    setClicked(true)
    setData(data)
  }, [])

  const downloadPdf = async () => {
    const element = document.getElementById("certificate-download-container");
    if (!element) {
      toast.error("Unable to generate certificate");
      return;
    }

    try {
      toast.warning("Downloading......");
      const captureWidth = Math.round(element.getBoundingClientRect().width);
      const captureHeight = Math.round(element.getBoundingClientRect().height);

      const canvas = await html2canvas(element, {
        scale: 3,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
      } as any);

      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("landscape", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
      pdf.save(`${data.name || "certificate"}-${data.title || "download"}.pdf`);
    } catch (error) {
      toast.error("Failed to generate PDF");
    }
  };

  const getCurrentDateString = () => {
    return new Date().toISOString().split('T')[0];
  };

  const handlePrint = () => {
    window.print();
  };

  const renderCertificate = (containerId?: string, fixedForDownload = false) => {
    return (
      <div
        id={containerId}
        className={`certificate-wrapper ${
          fixedForDownload ? "certificate-fixed-render certificate-export-mode" : ""
        }`}
        aria-hidden={fixedForDownload}
      >
        <div className="certificate">
          <img src={Layout} className="certificate-background" alt="Certificate Background" />
          <div className="certificate-content">
            <h2 className="certificate-name">{data.name || "Recipient Name"}</h2>
            <h1 className="certificate-title">
              <b>{data.title || "Course Title"}</b>
            </h1>
            <div className="certificate-date">
              <b>{data.date || formatDateWithCurrentYear(getCurrentDateString())}</b>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>{data.status ? <>
      <center className="no-print flex flex-wrap items-center justify-center gap-3 m-5">
        <button
          className="flex items-center gap-x-2 px-5 py-3 text-[14px] rounded-[10px] hover:cursor-pointer bg-ryd-primary text-white"
          onClick={downloadPdf}
        >
          Download as PDF
        </button>
        <button
          className="flex items-center gap-x-2 px-5 py-3 text-[14px] rounded-[10px] hover:cursor-pointer bg-gray-700 text-white"
          onClick={handlePrint}
        >
          Print certificate
        </button>
      </center>

      <div className="certificate-preview-shell">
        {renderCertificate("certificate-container")}
      </div>   </> : <><center><h1 className="m-5">Sorry you can't download this certificate</h1></center></>}
      {renderCertificate("certificate-download-container", true)}
    </>
  );
};

export default CertificateView;
